export function doesNodeDirectlyContainText(node: Node): boolean {
    const content = node.nodeValue;
    return content !== null && (/\u00A0/.test(content) || /\S/.test(content));
}
